import { application } from "./application"
import DropdownController from "./dropdown_controller"
import ModalController from "./modal_controller"
import PasswordValidationController from "./password_validation_controller"

application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("password-validation", PasswordValidationController)
